import React, { useEffect, useState } from "react";
import {
    Box,
    Dialog,
    LinearProgress,
    Typography
} from "@mui/material";

import { ButtonBase, FormSectionTitle } from "../Pedidos/styles";
import { atualizarStatusOS } from "./integracaoApi";
import { mensagemErroApi } from "./utils";

// Chave = statusOrigem_statusDestino, já que "G" (Gerado) pode ser tanto o destino de um
// Desconfirmar (vindo de Confirmado) quanto de um Reconsiderar (vindo de Ignorado).
const ROTULOS = {
    G_C: { titulo: "Confirmar OS", verbo: "Confirmar", progresso: "Confirmando OS..." },
    C_I: { titulo: "Integrar OS no SISDM", verbo: "Integrar", progresso: "Integrando OS no SISDM..." },
    C_G: { titulo: "Desconfirmar OS", verbo: "Desconfirmar", progresso: "Desconfirmando OS..." },
    G_X: {
        titulo: "Ignorar OS",
        verbo: "Ignorar",
        progresso: "Ignorando OS...",
        mensagemConfirmacao: "Ignorar uma OS no portal gerará divergências no SISDM. Deseja mesmo ignorar o item?"
    },
    X_G: { titulo: "Reconsiderar OS", verbo: "Reconsiderar", progresso: "Reconsiderando OS..." }
};

const ModalLoteStatus = ({ open, onClose, itens = [], novoStatus, periodo, usuario }) => {
    const [fase, setFase] = useState("confirmar");
    const [concluidas, setConcluidas] = useState(0);
    const [erros, setErros] = useState([]);

    const statusOrigem = itens[0]?.statusOS;
    const rotulos = ROTULOS[`${statusOrigem}_${novoStatus}`] || ROTULOS.G_C;

    useEffect(() => {
        if (open) {
            setFase("confirmar");
            setConcluidas(0);
            setErros([]);
        }
    }, [open]);

    async function handleExecutar() {
        setFase("executando");
        const falhas = [];
        let feitas = 0;

        for (const item of itens) {
            try {
                await atualizarStatusOS(item.osId, novoStatus, usuario);
            } catch (e) {
                const nome = item.clienteNome || item.distribuidorNome || `OS ${item.osId}`;
                falhas.push(`${nome}: ${mensagemErroApi(e, "erro inesperado")}`);
            } finally {
                feitas += 1;
                setConcluidas(feitas);
            }
        }

        setErros(falhas);
        setFase("resultado");
    }

    const progresso = itens.length === 0 ? 100 : Math.round((concluidas / itens.length) * 100);

    return (
        <Dialog
            open={open}
            onClose={fase === "executando" ? undefined : () => onClose(fase === "resultado", erros)}
            maxWidth="sm"
            fullWidth
            PaperProps={{ sx: { backgroundColor: "transparent", boxShadow: "none" } }}
        >
            <Box sx={{
                backgroundColor: 'white',
                py: 3,
                px: 4,
                my: 3,
                borderRadius: '30px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'start',
                width: '100%',
                position: 'relative',
                boxShadow: '0px 0px 7px rgba(0, 0, 0, 0.25)',
            }}>
                <FormSectionTitle label={rotulos.titulo} />

                {fase === "confirmar" && (
                    <>
                        <Typography variant="body2" sx={{ mt: 2 }}>
                            {rotulos.mensagemConfirmacao ||
                                `${rotulos.verbo} ${itens.length} OS para o período ${periodo?.slice(0, 4)}/${periodo?.slice(4, 6)}?`}
                        </Typography>

                        <Box sx={{ display: 'flex', gap: 2, mt: 3, width: '100%', justifyContent: 'flex-end' }}>
                            <ButtonBase variant="outlined" onClick={() => onClose(false)}>
                                Cancelar
                            </ButtonBase>
                            <ButtonBase variant="contained" onClick={handleExecutar}>
                                {rotulos.verbo}
                            </ButtonBase>
                        </Box>
                    </>
                )}

                {fase === "executando" && (
                    <Box sx={{ width: "100%", mt: 3 }}>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                            {rotulos.progresso} ({concluidas}/{itens.length})
                        </Typography>
                        <LinearProgress variant="determinate" value={progresso} aria-label="Progresso do lote" />
                    </Box>
                )}

                {fase === "resultado" && (
                    <>
                        <Typography variant="body2" sx={{ mt: 2, fontWeight: 600, color: erros.length === 0 ? "#2e7d32" : "#132350" }}>
                            {itens.length - erros.length} de {itens.length} OS processada(s) com sucesso.
                        </Typography>

                        {erros.map((mensagemErro, indice) => (
                            <Typography key={indice} variant="caption" color="error" display="block" sx={{ mt: 0.5 }}>
                                {mensagemErro}
                            </Typography>
                        ))}

                        <Box sx={{ display: 'flex', mt: 3, width: '100%', justifyContent: 'flex-end' }}>
                            <ButtonBase variant="contained" onClick={() => onClose(true, erros)}>
                                Fechar
                            </ButtonBase>
                        </Box>
                    </>
                )}
            </Box>
        </Dialog>
    );
};

export default React.memo(ModalLoteStatus);
